import { get, post, put } from "./index";
export function getList(params) {

    return get('/api/admin/advertising', params);
}
export function update(id, params) {
    return put(`/api/admin/advertising/${id}`, params);
}
export function add(params) {
    return post('/api/admin/advertising', params);
}
export function getDetails(id) {
    return get(`/api/admin/advertising/${id}`);
}
// export function update(id,params){
//     return put(`/api/admin/advertising/${id}`,params);
// }